import { put } from 'redux-saga/effects';

import * as Actions from '../actions';
import * as Constants from '../constants';

import { AbstractWatcher } from './abstract-watcher';

export class CreateStage extends AbstractWatcher {
  *setLoading(loading) {
    const { name: nameOption } = this.options;

    const payload = loading
      ? Constants.STAGES_LOADING_VALUES.LOADING
      : Constants.STAGES_LOADING_VALUES.LOADED;

    yield put(Actions.updateStagesLoadings({ [nameOption]: payload }));
  }

  *action(params) {
    const {
      after: afterOption,
      before: beforeOption,
      handler: handlerOption,
      name: nameOption,
    } = this.options;

    try {
      yield* beforeOption(params);
      yield* this.setLoading(true);
      yield* handlerOption(params);
      yield* afterOption(params);
    } catch (error) {
      const payload = AbstractWatcher.errorHandler(error);

      yield put(Actions.updateStagesErrors({ [nameOption]: payload }));
    } finally {
      yield* this.setLoading(false);
    }
  }
}
